<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22 11.5C22 17.5751 17.0751 22.5 11 22.5C4.92487 22.5 0 17.5751 0 11.5C0 5.42487 4.92487 0.5 11 0.5C17.0751 0.5 22 5.42487 22 11.5ZM12 7.0998C12 6.54751 11.5522 6.0998 11 6.0998C10.4477 6.0998 9.99996 6.54751 9.99996 7.0998V10.4998H6.59999C6.0477 10.4998 5.59999 10.9475 5.59999 11.4998C5.59999 12.0521 6.0477 12.4998 6.59999 12.4998H9.99996V15.8998C9.99996 16.4521 10.4477 16.8998 11 16.8998C11.5522 16.8998 12 16.4521 12 15.8998V12.4998H15.4C15.9523 12.4998 16.4 12.0521 16.4 11.4998C16.4 10.9475 15.9523 10.4998 15.4 10.4998H12V7.0998Z"
            fill="#206CFF"
        />
    </g>
</template>
<script>
export default {
    name: "PlusCircleBlue",
};
</script>
